import { generateURL, trackError } from 'utils/helpers';

const account = {
  resetPassword: (username) => {
    const url = generateURL('/request_password_reset');

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(username),
    })
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => {
        trackError(error);

        return {
          message: error.message,
        };
      });
  },

  login: (params) => {
    const url = generateURL('/login');

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => {
        trackError(error);

        return {
          message: error.message,
        };
      });
  },

  setPassword: (params) => {
    const url = generateURL('/set_password');
    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
      .then((response) => {
        if (response.status !== 200) {
          return Promise.reject(new Error('Failed to set password'));
        }

        return response.json();
      })
      .then((json) => json)
      .catch((error) => {
        trackError(error);

        return {
          message: error.message,
        };
      });
  },

  changePassword: (params) => {
    const url = generateURL('/client/change_password');
    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }).then((response) => {
      if (response.status !== 200) {
        return Promise.reject(new Error('Failed to change password'));
      }

      return response.json();
    });
  },

  logout: () => {
    const url = generateURL('/logout');

    return fetch(url, { method: 'POST' });
  },

  me: () => {
    const url = generateURL('/me');

    return fetch(url, {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => {
        trackError(error);

        return {
          message: error.message,
        };
      });
  },

  clientTemplates: () => {
    const url = generateURL('/client/templates');

    return fetch(url, {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => {
        trackError(error);

        return {
          message: error.message,
        };
      });
  },

  setPreferences: (params) => {
    const url = generateURL('/set_preferences');

    return fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    })
      .then((response) => response.json())
      .then((json) => json)
      .catch((error) => {
        trackError(error);

        return {
          message: error.message,
        };
      });
  },
};

export default account;
